export default __webpack_public_path__ + "static/media/Iconly-Bulk-Graph.51f960e1.svg";